export default {
    filtros: {
        ordem: 'Ordem',
        resultado: 'Resultado',
        origem: 'Origem',
        destino: 'Destino',
        titulo: 'Filtros',
        mostrar_filtros: 'Mostrar Filtros',
        esconder_filtros: 'Esconder Filtros',
        nome: 'Nome',
        codigo: 'Código',
        componente: 'Componente',
        material: 'Material',
        complement: 'Complemento',
        metodo: 'Método',
        metodos: 'Métodos',
        tempos: 'Tempos',
        escala: 'Escala',
        integracao: 'Integração',
        detalhes: 'Detalhes',
        botao_filtrar: 'Filtrar',
        integracoes: 'Integrações',
        logs: 'Logs',
    },    
    ordem: {
        titulo_pagina: 'De X Para de Ordem',
        exams: {
            empty: 'Nenhum exame encontrado para os filtros informados!',
            origem: 'Exames Origem',
            destino: 'Exames Destino',
            botao_salvar: 'Salvar',
            sucesso: 'De x Para, salvos com Sucesso!'
        }
    },
    resultado: {
        titulo_pagina: 'De X Para de Resultado',
        exams: {
            empty: 'Nenhum exame encontrado para os filtros informados!',
            origem: 'Exames Origem',
            destino: 'Exames Destino',
            parse_personalizado: 'Parse Personalizado',
            botao_salvar: 'Salvar',
            sucesso: 'De x Para, salvos com Sucesso!'
        }
    },
    metodo: {
        titulo_pagina: 'De X Para de Métodos',
        empty: 'Nenhum método encontrado!',
        origem: 'Métodos de Origem',
        destino: 'Métodos de Destino',
        botao_salvar: 'Salvar',
        sucesso: 'De x Para, salvos com Sucesso!'
    },
    material: {
        titulo_pagina: 'De X Para de Materiais',
        empty: 'Nenhum material encontrado!',
        origem: 'Materiais de Origem',
        destino: 'Materiais de Destino',
        botao_salvar: 'Salvar',
        sucesso: 'De x Para, salvos com Sucesso!'
    },
    complement: {
        titulo_pagina: 'De X Para de Complementos',
        empty: 'Nenhum complemento encontrado!',
        origem: 'Complementos  de Origem',
        destino: 'Complementos de Destino',
        botao_salvar: 'Salvar',
        sucesso: 'De x Para, salvos com Sucesso!'
    },
    tipo: {
        titulo_pagina: 'De X Para por Tipo',
        empty: 'Nenhum Item encontrado!',
        origem: 'Itens de Origem',
        destino: 'Itens de Destino',
        botao_salvar: 'Salvar',
        sucesso: 'De x Para, salvos com Sucesso!',
        selecione_tipo: 'Selecione o Tipo!',
        depara_sucesso: 'DeXPara\'s cadastrados com sucesso!',
        depara_erro: 'Erro ao Cadastrar DeXPara\'s!'
    },
    exame_resultado: {
        titulo_pagina: 'De X Para de Valor de Resultado',
        empty: 'Nenhum exame resultado encontrado!',
        exame: 'Exame',
        origem: 'Origem',
        destino: 'Destino',
        selecione_exame: 'Selecione o Exame!',
        depara_sucesso: 'DeXPara\'s cadastrados com sucesso!'
    },
    copia: {
        copiar_dexpara: 'Copiar De x Para',
        tipo_integracao: 'Tipo de Integração',
        para_integracao: 'Para a Integração',
        origem: 'Origem',
        destino: 'Destino',
        sucesso: 'A integração foi copiada com sucesso!',
        sim: 'Sim',
        nao: 'Não',
        erro: {
            vazio: 'Os campos tipo de integração e para a integração devem ser preenchidos!',
            integracao_origem: 'A integração de origem deve estar selecionada para copiá-la!',
            integracao_destino: 'A integração de destino deve estar selecionada para copiá-la!',
            copiar: 'Ocorreu um erro ao tentar copiar a integração!',
            tipo: 'O campo tipo deve estar selecionado para salvar a cópia de integração!'
        },
        confirmacao: {
            titulo: 'Cópia de Integração',
            mensagem: 'Tem certeza que deseja copiar essa integração?'
        }
    },
    log: {
        origem: 'Origem',
        destino: 'Destino',
        vazio: 'Sem log registrado.',
        ultimo: {
            info: 'Última manipulação feita por',
            complemento: 'em'
        }
    }
}
